import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-securityBatch",
  "use": "icon-securityBatch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-securityBatch\"><path d=\"M877.714286 182.857143v73.142857H438.857143v-73.142857h438.857143z m-548.571429-73.142857h-219.428571v219.428571h219.428571v-219.428571z m-73.142857 73.142857v73.142857h-73.142857v-73.142857h73.142857z m73.142857 219.428571h-219.428571v219.428572h219.428571v-219.428572z m-73.142857 73.142857v73.142858h-73.142857v-73.142858h73.142857z m73.142857 219.428572h-219.428571v219.428571h219.428571v-219.428571z m-73.142857 73.142857v73.142857h-73.142857v-73.142857h73.142857z m621.714286-292.571429v73.142858H438.857143v-73.142858h438.857143z m0 292.571429v73.142857H438.857143v-73.142857h438.857143z\" p-id=\"12564\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/securityBatch.svg
// module id = ilCz
// module chunks = 69